<template>
	<div class="account__section__container deposit">
		<payments-loader v-if="containerLoading" />
		<div v-else class="account__section global-card__type--block">
			<h3
				:class="{
					account__section__title: 1,
					deposit__title: 1,
				}"
			>
				{{ title }}
			</h3>
			<p
				:class="{
					account__section__desc: 1,
					deposit__desc: 1,
					'deposit__desc--error': context == 'error',
				}"
			>
				{{ desc }}
			</p>
			<div
				class="button__group account__section__button-group"
				style="margin-bottom: 10px; margin-top: 15px"
			>
				<button
					:class="{
						button: 1,
						rounded: 1,
						account__section__button: 1,
						button__secondary: value == selectedButton,
					}"
					:disabled="transacting"
					v-for="value in buttons"
					:key="value"
					@click="
						() => {
							amount += value;
							selectedButton = value;
						}
					"
				>
					+{{ value }}
				</button>
			</div>
			<error v-if="error">{{ error }}</error>

			<b-input
				:class="{ deposit: 1, input: 1, account__section__input: 1 }"
				name="deposit-amount"
				type="number"
				min="50"
				step="50"
				autocomplete="off"
				placeholder="Enter amount to deposit"
				:error="error"
				:disabled="loading || transacting"
				v-model="amount"
				style="margin-bottom: 10px"
				><small slot="desc"
					>Minimum {{ env.minimumDepositAmount | currency }}</small
				></b-input
			>
			<template v-if="!env.disabledFeatures.includes('paymentProviders')">
				<h3 class="account__section__title">Select Payment Provider</h3>
				<b-checkbox
					:value="selectedProvider.name == provider.name"
					v-for="provider in depositProviders"
					:key="provider.name"
					:label="$options.filters.toTitleCase(provider.name)"
					:name="'provider'"
					@click.native="setProvider(provider)"
					class="session__form__checkbox session__form__remember"
					:disabled="loading"
				/>
			</template>

			<b-button
				class="button button__secondary account__section__submit"
				:disabled="transacting"
				:loading="loading"
				:title="'Deposit'"
				@click="deposit"
			>
			</b-button>
		</div>
	</div>
</template>

<script>
import PaymentsLoader from "./PaymentsLoader.vue";
export default {
	components: {
		PaymentsLoader,
	},
	props: {
		injectedAmount: {
			type: Number,
			required: false,
			default: null,
		},
		title: {
			type: String,
			required: false,
			default: "Deposit",
		},
		desc: {
			type: String,
			required: false,
			default: "Send money into your Betika account",
		},
		context: {
			type: String,
			required: false,
			default: "info",
		},
		user: {
			type: Object,
			required: true,
		},
		transacting: {
			type: Boolean,
			default: false,
		},
		containerLoading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			selectedButton: null,
			buttons: [100, 250, 500, 1000],
			amount: null,
			loading: true,
			error: false,
			depositProviders: [{ name: "Loading" }, { name: "Loading" }],
			canShowBottomSheet: false,
			selectedProvider: {
				name: "interswitch",
			},
		};
	},
	watch: {
		amount(n, o) {
			n > 1000000 ? (this.amount = o) : false;
			n < 0 ? (this.amount = 50) : false;
		},
	},
	beforeMount() {
		if (!this.env.disabledFeatures.includes("paymentProviders")) {
			this.getDepositProviders();
		} else {
			this.loading = false;
		}
		if (this.injectedAmount) this.amount = this.injectedAmount;
	},

	methods: {
		setProvider(provider) {
			this.selectedProvider = provider;
		},
		getDepositProviders() {
			let vm = this;
			vm.$axios
				.get(`${BASE_V2_URL}deposit-providers`)
				.then((res) => {
					vm.depositProviders = res.data;
					vm.loading = false;
				})
				.catch((err) => {
					vm.error = true;
					vm.loading = false;
				});
		},
		deposit() {
			let vm = this;
			vm.error = false;
			if (vm.loading || vm.transacting) return;
			if (!vm.selectedProvider.name) return;
			if (vm.amount > 0) {
				vm.loading = true;

				if (vm.amount < vm.env.minimumDepositAmount) {
					vm.loading = false;
					return vm.$notifications.add({
						message:
							"Minimum deposit amount is  " +
							vm.$options.filters.currency(vm.env.minimumDepositAmount),
						title: "Deposit Amount",
						type: "warning",
						duration: 5000,
					});
				}

				if (vm.amount > vm.env.maximumDepositAmount) {
					vm.loading = false;
					return vm.$notifications.add({
						message:
							"Maximum deposit amount is  " +
							vm.$options.filters.currency(vm.env.maximumDepositAmount),
						title: "Deposit Amount",
						type: "warning",
						duration: 5000,
					});
				}

				const token = vm.$auth.getToken();
				let payload = {
					amount: vm.amount,
					token,
				};

				if (!vm.env.disabledFeatures.includes("paymentProviders")) {
					payload.provider = vm.selectedProvider.name;
				}

				vm.$tracking.deposit.attempt({
					mobile: vm.user.mobile,
					user_id: vm.user.id,
					wallet_balance: vm.user.balance,
					depositAmount: vm.amount,
					depositMethod: "ONLINE",
				});
				vm.$emit("is-transacting", true);
				let url =
					vm.env.depositWithdrawVersion == "v1"
						? `${BASE_URL}deposit`
						: `${BASE_V2_URL}deposit`;

				let successMessage =
					vm.env.depositWithdrawVersion == "v1"
						? "Ok.<br>If you do not get the M-PESA popup, you can also deposit by:<br>Go to M-PESA,<br>Lipa na M-PESA,<br>Pay Bill<br>Weka Business Number 290290<br>Account BETIKA"
						: "Success";
				let errorMessage =
					vm.env.depositWithdrawVersion == "v1"
						? "<br>You can also deposit by<br>Go to M-PESA,<br>Lipa na M-PESA,<br>Pay Bill<br>Weka Business Number 290290<br>Account BETIKA"
						: "";

				vm.$axios
					.post(url, payload)
					.then((response) => {
						vm.loading = false;
						vm.$emit("is-transacting", false);
						vm.$notifications.add({
							message: successMessage,
							type: "success",
							title: "Deposit initiated",
							duration: 15000,
						});

						vm.$tracking.deposit.start({
							mobile: vm.user.mobile,
							user_id: vm.user.id,
							depositMethod: "ONLINE",
							wallet_balance: vm.user.balance,
							depositAmount: vm.amount,
							message: "Success",
							isFirstDeposit: 0,
						});
						vm.amount = null;
						vm.$emit("close");
						if (response.data.url) window.open(response.data.url);
					})
					.catch((error) => {
						vm.loading = false;
						vm.$emit("is-transacting", false);
						vm.$tracking.deposit.failed({
							mobile: vm.user.mobile,
							user_id: vm.user.id,
							wallet_balance: vm.user.balance,
							depositMethod: "ONLINE",
							depositAmount: vm.amount,
							message: error.response
								? error.response.data.error.message + errorMessage
								: error.message + errorMessage,
						});
						if (error.response) {
							if (error.response.status == 401) {
								vm.$auth.logout();
								vm.$router.replace("/login");
								return;
							}
							try {
								vm.$notifications.add({
									message: error.response.data.error.message + errorMessage,
									type: "error",
									title: "Deposit failed",
									duration: 5000,
								});
							} catch (e) {
								vm.$notifications.add({
									message: "An error occurred. Please try again" + errorMessage,
									type: "error",
									title: "Deposit failed",
									duration: 5000,
								});
							}
						} else {
							vm.$notifications.add({
								message: "An error occurred. Please try again" + errorMessage,
								type: "error",
								title: "Deposit failed",
								duration: 5000,
							});
						}
					});
			} else {
				vm.error = "Please enter an amount";
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.deposit {
	margin-bottom: 15px;
	&__desc {
		&--error {
			color: var(--red);
			background: var(--light-red);
			padding: 5px;
			border-radius: 5px;
		}
	}

	.input.account__section__input > input {
		background: var(--white);
		border-radius: 4px;
	}
}
</style>
